import ROUTES from "../../constants/routes";
import { PAGENAMES, PARTNER_TYPE } from "../../constants/datalayer";
import { isAForm } from "./util";

export const prePathUrl = "/seguro-hogar";

export const getCurrentStep = location => {
    let step = 0;
    if (location.includes(ROUTES.HOME_INSURANCE.STEP2)) step = 1;
    if (location.includes(ROUTES.HOME_INSURANCE.STEP3)) step = 2;
    if (location.includes(ROUTES.HOME_INSURANCE.STEP4)) step = 3;
    if (location.includes(ROUTES.HOME_INSURANCE.STEP5)) step = 4;
    return step;
};

export const getPagePath = (url, partner, partnerType) => {
    url = orignalPath(url, partner, partnerType);
    const leadText = isAForm ? '-leads' : ''
    return prePathUrl + leadText + url;
};

export const orignalPath = (url, partner, partnerType) => {
    if (partnerType === PARTNER_TYPE.company) {
        url = url.replace(`/empresas/${partner}`, "");
    } else if (partnerType === PARTNER_TYPE.client) {
        url = url.replace(`/${partner}`, "");
    }
    return url;
};

export const getPageName = (url, partner, partnerType) => {
    url = orignalPath(url, partner, partnerType);
    return PAGENAMES[url];
};

export const getPathWithPartner = (path, partner, partnerType) => {
    if (partnerType === PARTNER_TYPE.client) {
        return `/${partner}${path}`;
    }
    if (partnerType === PARTNER_TYPE.company) {
        return `/empresas/${partner}${path}`;
    }

    return path;
};
